module.exports = __webpack_public_path__ + "static/media/cookbook-icon.c7a77a2a.png";